import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1637a898"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Dudas y Preguntas", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "En esta sección puedes tanto preguntar como resolver dudas del resto de compañeros, ya que está enfocada a solucionar todas las cuestiones que nos puedan surgir, como por ejemplo: \"Al realizar este ejercicio me da el siguiente error...\"", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_8 = {
  class: "card-container",
  style: {"margin-top":"-80px"}
}

import ItemCard from '@/components/cards/ItemCard.vue'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import main from '@/data/main.js';

export default /*#__PURE__*/_defineComponent({
  __name: 'ForumChooseView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createVNode(ItemCard, {
          title: "Cursos",
          description: "Dudas y preguntas concretas, en este caso, sobre una lección específica de un curso concreto.",
          img: _unref(main).QUESTION_COURSES,
          route: "forum-course"
        }, null, 8, ["img"]),
        _createVNode(ItemCard, {
          title: "Generales",
          description: "Dudas y preguntas generales, no necesariamente tienen que ver con un curso concreto.",
          img: _unref(main).QUESTION_COURSES_GENERAL,
          route: "forum-general"
        }, null, 8, ["img"])
      ])
    ]),
    _: 1
  }))
}
}

})